import * as React from "react";
const SvgFiRrCloudSunRain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-sun-rain_svg__a)">
      <path
        fill="#062147"
        d="M18.986 24a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1m-4 0a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1m-4 0a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1M8 22.487a1 1 0 0 1-.6-.2 3.45 3.45 0 0 1-1.281-1.882 3.5 3.5 0 0 1 2-4.142 6.35 6.35 0 0 1 .056-2.732 6 6 0 0 1 11.368-.854c.136.324.286.358.587.426l.178.043a5.01 5.01 0 0 1 3.557 6 4.9 4.9 0 0 1-1.117 2.154 1.002 1.002 0 0 1-1.5-1.328 2.9 2.9 0 0 0 .664-1.272 3.02 3.02 0 0 0-2.132-3.621 2.65 2.65 0 0 1-2.08-1.633 4 4 0 0 0-7.613 2.354 2.016 2.016 0 0 1-1.179 2.3 1.494 1.494 0 0 0-.852 1.8c.087.316.278.593.541.787a1 1 0 0 1-.6 1.8zM2.073 14a1 1 0 0 1-.5-1.866l2.248-1.3A5.5 5.5 0 0 1 3.6 10H1a1 1 0 0 1 0-2h2.589a6 6 0 0 1 .205-.81L1.552 5.915a1 1 0 0 1 .988-1.738l2.239 1.272q.294-.35.643-.649L4.134 2.572a1 1 0 0 1 1.732-1l1.29 2.235c.148-.052.3-.1.451-.135q.197-.048.393-.083V1a1 1 0 0 1 2 0v2.6q.408.075.8.212l1.282-2.255a1 1 0 0 1 1.738.988l-1.28 2.253q.33.279.615.606l2.273-1.267a1 1 0 1 1 .994 1.736L14.167 7.16a2.02 2.02 0 0 1-2.521-.451 3.5 3.5 0 0 0-3.557-1.1A3.43 3.43 0 0 0 5.611 8.1a3.51 3.51 0 0 0 1.056 3.514A1 1 0 0 1 5.333 13.1a5.5 5.5 0 0 1-.517-.53l-2.244 1.3a1 1 0 0 1-.499.13"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-sun-rain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudSunRain;
